// src/components/bookingModel/BookingWizard.jsx

import React, { useContext } from "react";
import Step1Verification from "./stepper-components/StepOne";
import Step2Identity from "./stepper-components/StepTwo";
import { BookingContext } from "./bookingContext/BookingContex";
import Step3Summary from "./stepper-components/StepThree";

// import { useBooking } from "./bookingContext/BookingContex";


export default function BookingWizard({onAuthenticationSuccess, closeModel}) {
//   const { step } = useBooking();

const {step} = useContext(BookingContext);

  switch (step) {
    case 1:
      return <Step1Verification />;
    case 2:
      return <Step2Identity />;
    case 3:
      return <Step3Summary />;
    default:
      return null;
  }
}
